export default __webpack_public_path__ + "9029ef3.png";